import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from 'components/page/pageModule.js'
import preload from 'components/enhancer/preload'
import composeHOC from 'shared/utils/composeHOC'
import Meta from 'components/layout/Meta';

class ProductDetail extends Component {

  componentDidMount(){

  }
  render() {
    const {page} = this.props
    return(
      <div className="rightCon companyIntroduction">
        <Meta location={this.props.location} title={page.title + "-产品介绍"}/>
        <div className="mgauto">
          <h3>
            借款咨询
            <p>LOAN CONSULTATION</p>
            <span className="redLine"></span>
          </h3>
          <div dangerouslySetInnerHTML={{__html: page && page.content}}>
          </div>
        </div>
      </div>
    )
  }
}


export default composeHOC(
  connect(state => ({
    page: state.common.page
  }), { }),
  preload(({dispatch, routes, location}) => {
    const lastRoute = routes[routes.length - 1]
    const catname = lastRoute.catname || lastRoute.path
    return Promise.all([
      dispatch(actions.getPageContent(catname))
    ])
  })
)(ProductDetail)



// WEBPACK FOOTER //
// ./modules/productIntroduction/ProductDetail.js